import { render, staticRenderFns } from "./CancelarEnvio.vue?vue&type=template&id=80063264"
import script from "./CancelarEnvio.vue?vue&type=script&lang=js"
export * from "./CancelarEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports